<template>
  <div class="flex items-start rounded border px-4 py-3 text-sm" :class="toneClass">
    <BaseIcon :icon="icon || defaultIcon" class="mt-0.5 mr-3 flex-shrink-0" :class="iconClass" />
    <div class="leading-relaxed"><slot /></div>
  </div>
</template>

<script>
// Note box, kept quiet: grey surfaces for muted and info, colour only for a
// warning or a refusal. tone: muted (default) | info | warn | bad
export default {
  name: "SoNote",
  props: {
    tone: { type: String, default: "muted" },
    icon: { type: String, default: "" },
  },
  computed: {
    toneClass() {
      return {
        muted: "bg-white border-secondary-200 text-secondary-600",
        info: "bg-secondary-50 border-secondary-200 text-secondary-700",
        warn: "bg-amber-50 border-amber-200 text-amber-900",
        bad: "bg-red-50 border-red-200 text-red-800",
      }[this.tone];
    },
    iconClass() {
      return { muted: "text-secondary-400", info: "text-secondary-500", warn: "text-amber-600", bad: "text-red-500" }[this.tone];
    },
    defaultIcon() {
      return { muted: "info-circle", info: "info-circle", warn: "exclamation-triangle", bad: "exclamation-circle" }[this.tone];
    },
  },
};
</script>
